import PropTypes from 'prop-types'
import React from 'react'
import styles from './list_table.module.scss'
import LoadingIndicator from './loading_indicator'

const TableHeader = ({ headerRenderer }) => {
  const header = headerRenderer()
  return header ? <thead>{header}</thead> : null
}

TableHeader.propTypes = {
  headerRenderer: PropTypes.func.isRequired
}

const TableBody = ({ cols, items, error, itemRenderer, emptyMessageRenderer }) => {
  if (error) {
    return (
      <tbody>
        <tr>
          <td colSpan={cols}>
            <div className={styles.innerMessageWrapper}>
              <div className={styles.error}>
                <strong>{I18n.t('components.list_table.message.error.1')}</strong>
                <p>{I18n.t('components.list_table.message.error.2')}</p>
                <p>{error.message}</p>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    )
  }

  if (items.length === 0) {
    return (
      <tbody>
        <tr>
          <td colSpan={cols}>
            <div className={styles.innerMessageWrapper}>
              <div className={styles.notice}>{emptyMessageRenderer()}</div>
            </div>
          </td>
        </tr>
      </tbody>
    )
  }

  return <tbody>{items.map(item => itemRenderer(item))}</tbody>
}

TableBody.propTypes = {
  cols: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  error: PropTypes.instanceOf(Error),
  itemRenderer: PropTypes.func.isRequired,
  emptyMessageRenderer: PropTypes.func.isRequired
}

TableBody.defaultProps = {
  error: null
}

const TableFooter = ({ footerRenderer }) => {
  const footer = footerRenderer()
  return footer ? <tfoot>{footer}</tfoot> : null
}

TableFooter.propTypes = {
  footerRenderer: PropTypes.func.isRequired
}

const ListTable = ({
  cols,
  items,
  error,
  isLoading,
  headerRenderer,
  itemRenderer,
  footerRenderer,
  emptyMessageRenderer
}) => {
  if (isLoading) {
    return <LoadingIndicator />
  }

  return (
    <table className={styles.table}>
      <TableHeader headerRenderer={headerRenderer} />
      <TableBody
        cols={cols}
        items={items}
        error={error}
        itemRenderer={itemRenderer}
        emptyMessageRenderer={emptyMessageRenderer}
      />
      <TableFooter footerRenderer={footerRenderer} />
    </table>
  )
}

ListTable.propTypes = {
  cols: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  error: PropTypes.instanceOf(Error),
  isLoading: PropTypes.bool.isRequired,
  headerRenderer: PropTypes.func,
  itemRenderer: PropTypes.func.isRequired,
  footerRenderer: PropTypes.func,
  emptyMessageRenderer: PropTypes.func.isRequired
}

ListTable.defaultProps = {
  error: null,
  headerRenderer: () => null,
  footerRenderer: () => null
}

export default ListTable
